export {
  default,
} from '@/components/pages/about/pcce';
